export default "__VITE_ASSET__CQd$A7lP__"